import React from 'react'
import { InputField } from '@commonComponents/formComponents/inputField'

const MUFreeText = (props) => {
    const {
        translate,
        fieldName: { key, text, value },
        fieldValue,
        setFieldValue
    } = props

    return (
        <InputField
            isLabel={false}
            id={`${key}`}
            type='text'
            label={translate(`${text}`, { ns: ['default', `${text}`] })}
            className={'field-bg'}
            clearInput={false}
            value={fieldValue}
            disabled={!value?.trim()}
            onChange={(value) => setFieldValue(value)}
        />
    )
}

export default MUFreeText